import { Component } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { DropDown } from '../drop-down/drop-down';

@Component({
  selector: 'app-aside-header',
  imports: [
    SvgIconComponent,
    DropDown
  ],
  templateUrl: './aside-header.html',
  styleUrl: './aside-header.scss'
})
export class AsideHeader {

}
